export function playEarnSound() {
  const audio = new Audio('/sound/earn.wav');
  audio.play().catch((error) => {
    console.error('Audio playback failed:', error);
  });
}
